<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D16wkR/tc-custom/9781467467162.jpg?1742010408940" alt="This image is the cover for the book Wisdom from the Witch of Endor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wisdom from the Witch of Endor
      </h1>
      <p class="bookDescription body article font2">
        <b>Four simple rules, amazing results—how wisdom from an overlooked biblical hero can change your life! </b><br/>  <br/> Tikva Frymer-Kensky shows readers how a seemingly minor story in the first book of Samuel can teach them key lessons to dramatically improve their lives. Saul, abandoned by God, approaches a medium in the village of Endor to call up the spirit of Samuel. Though Saul had outlawed her craft, she helped him when he promised her safety. And after Samuel prophesied Saul’s death, she showed the shaken king hospitality. <br/>  <br/> Determination. Excellence. Caution. Benevolence. Four qualities of the “witch” of Endor will bring you success, even when the whole world stands against you. Are you ready to follow your dreams? To succeed when others tell you to give up? Embrace the wisdom of a little-known hero from the Bible—and see how it leads you to the life you were meant to live.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tikva Frymer-Kensky, Adele Reinhartz
      </h2>
      
      <p class="authorDescription body article"><B>Tikva Frymer-Kensky </B>(1943&ndash;2006) was professor of Hebrew Bible and history of Judaism at the University of Chicago Divinity School. A pioneer in the study of Scripture, she authored <I>Reading the Women of the Bible</I>, <I>In the Wake of the Goddesses</I>, and <I>Motherprayer: The Pregnant Woman&rsquo;s Spiritual Companion</I>, among other books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dacb581a